import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const NavLink = ({ to, children, testid }) => (
    <Link
      to={to}
      onClick={() => setOpen(false)}
      data-testid={testid}
      className={`text-sm font-medium tracking-tight transition-colors ${
        pathname === to ? "text-[#C05C42]" : "text-[#1B2A22] hover:text-[#C05C42]"
      }`}
    >
      {children}
    </Link>
  );

  return (
    <nav className="glass fixed top-0 left-0 right-0 z-50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-logo">
          <div className="w-8 h-8 rounded-full bg-[#1B2A22] text-white flex items-center justify-center font-display font-bold text-sm">C</div>
          <span className="font-display font-bold text-lg tracking-tight">Caravan Reisen</span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          <NavLink to="/" testid="nav-home">Start</NavLink>
          <NavLink to="/fahrzeuge" testid="nav-fleet">Fahrzeuge</NavLink>
          <NavLink to="/ueber-uns" testid="nav-about">Über uns</NavLink>
          <NavLink to="/kontakt" testid="nav-contact">Kontakt</NavLink>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/admin" className="btn-outline text-sm" data-testid="nav-admin">Admin</Link>
          <Link to="/fahrzeuge" className="btn-primary text-sm" data-testid="nav-cta-book">Jetzt buchen</Link>
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#D8D6D0] bg-[#F9F8F6] px-6 py-6 flex flex-col gap-5">
          <NavLink to="/" testid="mnav-home">Start</NavLink>
          <NavLink to="/fahrzeuge" testid="mnav-fleet">Fahrzeuge</NavLink>
          <NavLink to="/ueber-uns" testid="mnav-about">Über uns</NavLink>
          <NavLink to="/kontakt" testid="mnav-contact">Kontakt</NavLink>
          <Link to="/admin" className="btn-outline" onClick={() => setOpen(false)}>Admin</Link>
          <Link to="/fahrzeuge" className="btn-primary" onClick={() => setOpen(false)}>Jetzt buchen</Link>
        </div>
      )}
    </nav>
  );
}
